import { Fragment } from "react"
import { useTranslation } from "react-i18next"
import { displayKey, parseBinding } from "@/lib/shortcuts"
import { cn } from "@/lib/utils"

function Kbd({ className, children }: { className?: string; children: string }) {
  return (
    <kbd
      className={cn(
        "type-micro inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-sm border border-border bg-surface-2 px-1 font-sans font-medium text-muted-foreground",
        className,
      )}
    >
      {children}
    </kbd>
  )
}

/**
 * Renders a binding such as "g i" or "mod+k" as keys. A space is a sequence
 * (G then I) and a plus is a chord (held together).
 */
function Shortcut({ keys, className }: { keys: string; className?: string }) {
  const { t } = useTranslation("shell")
  const strokes = parseBinding(keys)
  return (
    <span className={cn("inline-flex items-center gap-1", className)}>
      {strokes.map((stroke, index) => (
        <Fragment key={`${stroke}-${index}`}>
          {index > 0 ? (
            <span className="type-micro text-tertiary">{t("shortcuts.then")}</span>
          ) : null}
          <span className="inline-flex items-center gap-0.5">
            {stroke.split("+").map((key) => (
              <Kbd key={key}>{displayKey(key)}</Kbd>
            ))}
          </span>
        </Fragment>
      ))}
    </span>
  )
}

export { Kbd, Shortcut }
